import { PrecipitationProvider } from '../providers/precipitationProvider.js';
import { AsyncAction } from '../../base-classes/asyncAction';


export const GET_PRECIPITATION_MONTHLY_BY_LATLON = new AsyncAction('GET_PRECIPITATION_MONTHLY_BY_LATLON');
export const GET_PRECIPITATION_YEARLY_BY_LATLON = new AsyncAction('GET_PRECIPITATION_YEARLY_BY_LATLON');


import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export function getPrecipitationMonthlyByLatLon(...params) {
    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        lengthUnit: undefined,
        verbose: undefined,
        refresh: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_PRECIPITATION_MONTHLY_BY_LATLON.base,
        payload: getPrecipitationMonthly(paramsObject)
    };
}
export function getPrecipitationYearlyByLatLon(...params) {
    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        lengthUnit: undefined,
        verbose: undefined,
        refresh: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_PRECIPITATION_YEARLY_BY_LATLON.base,
        payload: getPrecipitationYearly(paramsObject)
    };
}

async function getPrecipitationMonthly({ latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh, lengthUnit }) {
    const op = new PrecipitationProvider(baseUrl, authId, secret);
    const results = await op.getPrecipitationMonthly(latitude, longitude, stdParameters, verbose, refresh, lengthUnit);
    return results;
}
async function getPrecipitationYearly({ latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, refresh, lengthUnit }) {
    const op = new PrecipitationProvider(baseUrl, authId, secret);
    const results = await op.getPrecipitationYearly(latitude, longitude, stdParameters, verbose, refresh, lengthUnit);
    return results;
}
